import {createAction, props} from '@ngrx/store';
import {
  ApiCreateRuleRequestDto,
  ApiGetRulesResponseDto,
  ApiRuleResponseDto,
  ApiUpdateRuleRequestDto,
} from '@birco/rainmesh-api';
import {RuleFilter} from './rule.state';
import {RuleFormModel} from '../models/rule-form-model.interface';

const ACTION_PREFIX = '[Rule]';

export const RuleActions = {
  public: {
    updateRuleFilter: createAction(
      `${ACTION_PREFIX} updateRuleFilter`,
      props<{
        filter: RuleFilter
      }>(),
    ),

    loadRuleWithId: createAction(
      `${ACTION_PREFIX} loadRuleWithId`,
      props<{
        id: string,
        skipIfInStore: boolean,
      }>(),
    ),

    loadAllRulesByFilters: createAction(
      `${ACTION_PREFIX} loadAllRulesByFilters`,
      props<{
        filter: RuleFilter
      }>(),
    ),

    createOrUpdateRule: createAction(
      `${ACTION_PREFIX} createOrUpdateRule`,
      props<{
        id?: string | null,
        requestDto: RuleFormModel,
      }>(),
    ),

    deleteRuleById: createAction(
      `${ACTION_PREFIX} deleteRuleById`,
      props<{
        id: string
      }>(),
    ),

    updateIsActive: createAction(
      `${ACTION_PREFIX} updateIsActive`,
      props<{
        id: string,
        isActive: boolean,
      }>(),
    )
  },

  private: {
    loadRulesWithFilters: createAction(
      `${ACTION_PREFIX} loadRulesWithFilters`,
    ),

    loadRulesSuccess: createAction(
      `${ACTION_PREFIX} loadRulesSuccess`,
      props<{
        rulesResponseDto: ApiGetRulesResponseDto
      }>(),
    ),

    loadRulesFailure: createAction(
      `${ACTION_PREFIX} loadRulesFailure`,
      props<{
        error: any
      }>(),
    ),

    loadRuleSuccess: createAction(
      `${ACTION_PREFIX} loadRuleSuccess`,
      props<{
        ruleResponseDto: ApiRuleResponseDto
      }>(),
    ),

    skipLoadRuleWithExisting: createAction(
      `${ACTION_PREFIX} skipLoadRuleWithExisting`,
    ),

    loadRuleFailure: createAction(
      `${ACTION_PREFIX} loadRuleFailure`,
      props<{
        error: any
      }>(),
    ),

    createRule: createAction(
      `${ACTION_PREFIX} createRule`,
      props<{
        requestDto: ApiCreateRuleRequestDto
      }>(),
    ),

    createRuleSuccess: createAction(
      `${ACTION_PREFIX} createRuleSuccess`,
      props<{
        ruleResponseDto: ApiRuleResponseDto
      }>(),
    ),

    createRuleFailure: createAction(
      `${ACTION_PREFIX} createRuleFailure`,
      props<{
        error: any
      }>(),
    ),

    updateRuleWithId: createAction(
      `${ACTION_PREFIX} updateRuleWithId`,
      props<{
        id: string,
        requestDto: ApiUpdateRuleRequestDto
      }>(),
    ),

    updateRuleSuccess: createAction(
      `${ACTION_PREFIX} updateRuleSuccess`,
      props<{
        ruleResponseDto: ApiRuleResponseDto,
      }>(),
    ),

    updateRuleFailure: createAction(
      `${ACTION_PREFIX} updateRuleFailure`,
      props<{
        id: string,
        error: any,
      }>(),
    ),

    deleteRuleSuccess: createAction(
      `${ACTION_PREFIX} deleteRuleSuccess`,
      props<{
        id: string,
      }>(),
    ),

    deleteRuleFailure: createAction(
      `${ACTION_PREFIX} deleteRuleFailure`,
      props<{
        id: string,
        error: any,
      }>(),
    ),

    updateIsActiveSuccess: createAction(
      `${ACTION_PREFIX} updateIsActiveSuccess`,
      props<{
        responseDto: ApiRuleResponseDto,
      }>(),
    ),

    updateIsActiveFailure: createAction(
      `${ACTION_PREFIX} updateIsActiveFailure`,
      props<{
        id: string,
        error: any,
      }>(),
    ),

    loadRulesWithProvidedFilters: createAction(
      `${ACTION_PREFIX} loadRulesWithProvidedFilters`,
      props<{
        filter: RuleFilter,
      }>(),
    ),

    loadRulesWithProvidedFiltersSuccess: createAction(
      `${ACTION_PREFIX} loadRulesWithProvidedFiltersSuccess`,
      props<{
        responseDto: ApiGetRulesResponseDto,
      }>(),
    ),

    loadRulesWithProvidedFiltersFailure: createAction(
      `${ACTION_PREFIX} loadRulesWithProvidedFiltersFailure`,
      props<{
        error: any,
      }>(),
    ),

    loadAllRulesByFiltersSuccess: createAction(
      `${ACTION_PREFIX} loadAllRulesByFiltersSuccess`,
    ),

    loadAllRulesByFiltersFailure: createAction(
      `${ACTION_PREFIX} loadAllRulesByFiltersFailure`,
      props<{ error: any }>(),
    ),

    loadNextOfAll: createAction(
      `${ACTION_PREFIX} loadNextOfAll`,
      props<{
        page: number,
        filter: RuleFilter
      }>(),
    ),

    loadNextOfAllSuccess: createAction(
      `${ACTION_PREFIX} loadNextOfAllSuccess`,
      props<{ rulesResponseDto: ApiGetRulesResponseDto }>(),
    ),

    loadNextOfAllFailure: createAction(
      `${ACTION_PREFIX} loadNextOfAllFailure`,
      props<{ error: any }>(),
    ),
  }
}
